import imageCompression from "browser-image-compression";
import { useEffect, useState } from "react";

function useImageCompression(initialFile = null, fieldName, formRef) {
  const [compressedFile, setCompressedFile] = useState(initialFile);
  const [error, setError] = useState(null);
  const [isCompressing, setIsCompressing] = useState(false);

  function blobToFile(blob) {
    const fileName = blob.name;
    const fileType = blob.type;
    const lastModified = blob.lastModified;

    // Assuming you have the compressed blob, you can create a new File object like this:
    const newFile = new File([blob], fileName, {
      type: fileType,
      lastModified: lastModified,
    });

    return newFile;
  }
  useEffect(() => {
    async function compressFile(file) {
      try {
        const maxSizeMB = 1;

        // Check if the file size is less than 1MB, return the original file without compression
        if (file.size <= maxSizeMB * 1024 * 1024) {
          // setCompressedFile(file);
          // formRef.current.setFieldValue(fieldName, file);
          return;
        }
        const options = {
          maxSizeMB,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        setIsCompressing(true);
        const compressedBlob = await imageCompression(file, options);
        setIsCompressing(false);

        const compressedFile = blobToFile(compressedBlob);
        // setCompressedFile(compressedFile);
        //formRef.current.setFieldValue(fieldName, compressedFile);
      } catch (error) {
        // formRef.current.setFieldValue(fieldName, initialFile);
        setCompressedFile(null);
        setError(error);
        setIsCompressing(false);
      }
    }

    if (initialFile) {
      compressFile(initialFile);
    }

    // Clean up function if needed
    return () => {
      // Clean up code here, if any
    };
  }, [fieldName, formRef, initialFile]);

  return { compressedFile, error, isCompressing };
}

export default useImageCompression;
